/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/sessions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Sessions redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Sunday, January 28, 2024 - 11:28 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/01/28  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sessionid: 0,
  companyid: 0,
  userid: 0,
  error: null,
  defaultToolPanel: "filter",
  roworder: "STARTVISIT DESC",
  search: "",
  columnState: [],
};

const intFields = ["sessionid", "companyid", "userid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const sessionSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    updateSessionID: (state, action) => updateFieldReducer(state, action, "sessionid"),
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateUserID: (state, action) => updateFieldReducer(state, action, "userid"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const { updateSessionID, updateCompanyID, updateUserID, updateDefaultToolPanel, updateColumnState } =
  sessionSlice.actions;

export default sessionSlice.reducer;
